<script >
import { THEME } from '../common/enum';
import { defineProps } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  selected: Boolean,
  showCollect: Boolean,
  showTrade: Boolean,
  tradeButtonText: String,
  theme: String,
  textColor: String,
  actionFn: Function
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const clickHandler = (event, flag) => {
    console.log('clickHandler1', event, flag);
    //检查actionFn是否存在
    if (!props.actionFn || typeof props.actionFn !== 'function') {
      return;
    }
    console.log('clickHandler2', event, flag);
    props.actionFn(event, flag);
  };
  return {
    THEME,
    props,
    clickHandler
  };
};
export default __sfc_main;
</script>
<template>
    <div class="stock-op">
        <svg
            v-if="props.selected && props.showCollect"
            @click.stop="(event) => clickHandler(event, false)"
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="36" cy="36" r="35.5" stroke="#F03A55" />
            <path
                d="M29.25 25.5C24.6937 25.5 21 29.1937 21 33.75C21 42 30.75 49.5 36 51.2447C41.25 49.5 51 42 51 33.75C51 29.1937 47.3063 25.5 42.75 25.5C39.9598 25.5 37.493 26.8852 36 29.0054C34.507 26.8852 32.0402 25.5 29.25 25.5Z"
                fill="#F03A55"
            />
        </svg>
        <svg
            v-else-if="props.showCollect && props.theme == THEME.LIGHT"
            @click.stop="(event) => clickHandler(event, true)"
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="36" cy="36" r="35" stroke="#DADADA" stroke-width="2" />
            <g style="mix-blend-mode: luminosity">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M34.3439 29.1555L36.0004 30.7357L37.657 29.1555C38.8878 27.9815 40.8337 26.9 42.8854 26.9C46.1671 26.9 48.9004 29.4328 48.9004 33.2568C48.9004 33.9589 48.8342 34.6397 48.7088 35.3H51.1442C51.2463 34.6394 51.3004 33.9584 51.3004 33.2568C51.3004 28.1486 47.5336 24.5 42.8854 24.5C40.0396 24.5 37.5304 25.9595 36.0004 27.4189C34.4704 25.9595 31.9612 24.5 29.1154 24.5C24.5254 24.5 20.7004 28.1486 20.7004 33.2568C20.7004 41.1449 27.5415 46.4228 32.4201 49.4263C34.6045 50.7712 37.3964 50.7712 39.5808 49.4263C39.6111 49.4077 39.6414 49.389 39.6719 49.3702L38.1659 47.4746C36.7771 48.2513 35.0395 48.2206 33.6783 47.3826C31.3235 45.9329 28.6319 44.0136 26.5456 41.6027C24.4753 39.2105 23.1004 36.455 23.1004 33.2568C23.1004 29.4437 25.8812 26.9 29.1154 26.9C31.1671 26.9 33.1131 27.9815 34.3439 29.1555Z"
                    fill="#1D1D1D"
                />
                <path d="M40.2671 43.2898L51.5171 43.2898" stroke="#1D1D1D" stroke-width="2.4" stroke-linecap="round" />
                <path d="M45.8921 37.6648L45.8921 48.9148" stroke="#1D1D1D" stroke-width="2.4" stroke-linecap="round" />
            </g>
        </svg>
        <svg
            v-else-if="props.showCollect && props.theme == THEME.DARK"
            @click.stop="(event) => clickHandler(event, true)"
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="36" cy="36" r="35" fill="#2E2E33" stroke="#DADADA" stroke-width="2" />
            <g style="mix-blend-mode: luminosity">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M34.3436 29.1555L36.0002 30.7357L37.6567 29.1555C38.8875 27.9815 40.8335 26.9 42.8852 26.9C46.1669 26.9 48.9002 29.4328 48.9002 33.2568C48.9002 33.9589 48.8339 34.6397 48.7086 35.3H51.144C51.2461 34.6394 51.3002 33.9584 51.3002 33.2568C51.3002 28.1486 47.5333 24.5 42.8852 24.5C40.0394 24.5 37.5302 25.9595 36.0002 27.4189C34.4702 25.9595 31.961 24.5 29.1152 24.5C24.5252 24.5 20.7002 28.1486 20.7002 33.2568C20.7002 41.1449 27.5412 46.4228 32.4198 49.4263C34.6043 50.7712 37.3961 50.7712 39.5806 49.4263C39.6109 49.4077 39.6412 49.389 39.6716 49.3702L38.1656 47.4746C36.7769 48.2513 35.0392 48.2206 33.678 47.3826C31.3233 45.9329 28.6316 44.0136 26.5453 41.6027C24.4751 39.2105 23.1002 36.455 23.1002 33.2568C23.1002 29.4437 25.8809 26.9 29.1152 26.9C31.1669 26.9 33.1128 27.9815 34.3436 29.1555Z"
                    fill="white"
                />
                <path d="M40.2666 43.2898L51.5166 43.2898" stroke="white" stroke-width="2.4" stroke-linecap="round" />
                <path d="M45.8916 37.6648L45.8916 48.9148" stroke="white" stroke-width="2.4" stroke-linecap="round" />
            </g>
        </svg>
        <svg
            v-else-if="props.showCollect"
            @click.stop="(event) => clickHandler(event, true)"
            width="72"
            height="72"
            viewBox="0 0 72 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="36" cy="36" r="35" :stroke="textColor" stroke-width="2" />
            <g>
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M34.3436 29.1555L36.0002 30.7357L37.6567 29.1555C38.8875 27.9815 40.8335 26.9 42.8852 26.9C46.1669 26.9 48.9002 29.4328 48.9002 33.2568C48.9002 33.9589 48.8339 34.6397 48.7086 35.3H51.144C51.2461 34.6394 51.3002 33.9584 51.3002 33.2568C51.3002 28.1486 47.5333 24.5 42.8852 24.5C40.0394 24.5 37.5302 25.9595 36.0002 27.4189C34.4702 25.9595 31.961 24.5 29.1152 24.5C24.5252 24.5 20.7002 28.1486 20.7002 33.2568C20.7002 41.1449 27.5412 46.4228 32.4198 49.4263C34.6043 50.7712 37.3961 50.7712 39.5806 49.4263C39.6109 49.4077 39.6412 49.389 39.6716 49.3702L38.1656 47.4746C36.7769 48.2513 35.0392 48.2206 33.678 47.3826C31.3233 45.9329 28.6316 44.0136 26.5453 41.6027C24.4751 39.2105 23.1002 36.455 23.1002 33.2568C23.1002 29.4437 25.8809 26.9 29.1152 26.9C31.1669 26.9 33.1128 27.9815 34.3436 29.1555Z"
                    :stroke="textColor"
                    :fill="textColor"
                />
                <path
                    d="M40.2666 43.2898L51.5166 43.2898"
                    :stroke="textColor"
                    :fill="textColor"
                    stroke-width="2.4"
                    stroke-linecap="round"
                />
                <path
                    d="M45.8916 37.6648L45.8916 48.9148"
                    :stroke="textColor"
                    :fill="textColor"
                    stroke-width="2.4"
                    stroke-linecap="round"
                />
            </g>
        </svg>

        <button v-if="showTrade" class="trade-op">
            {{ tradeButtonText }}
        </button>
    </div>
</template>
